(function (root) {
  'use strict';

  /*
   * window.twrdFormatMoney(cents, options)
   * Mirrors snippets/twrd-money.liquid: the shop's money_format for the active
   * currency ("$65", "699 kr", "€89"), decimals only when they are not zero,
   * no ISO code. options.withCode === false returns the bare number.
   * theme.money_format is printed by layout/theme.liquid from shop.money_format,
   * which Shopify sets per presentment currency.
   */

  var SEPARATORS = {
    amount: { thousands: ',', decimal: '.', decimals: 2 },
    amount_no_decimals: { thousands: ',', decimal: '.', decimals: 0 },
    amount_with_comma_separator: { thousands: '.', decimal: ',', decimals: 2 },
    amount_no_decimals_with_comma_separator: { thousands: '.', decimal: ',', decimals: 0 },
    amount_with_apostrophe_separator: { thousands: "'", decimal: '.', decimals: 2 },
    amount_with_space_separator: { thousands: ' ', decimal: ',', decimals: 2 },
    amount_with_period_and_space_separator: { thousands: ' ', decimal: '.', decimals: 2 }
  };
  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function moneyFormat() {
    var fmt = root.theme && root.theme.money_format;
    return typeof fmt === 'string' && PLACEHOLDER.test(fmt) ? fmt : '';
  }

  function decodeText(html) {
    return String(html)
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&euro;/g, '€')
      .replace(/&pound;/g, '£')
      .replace(/&amp;/g, '&')
      .trim();
  }

  function group(digits, sep) {
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function number(value, sep) {
    if (sep.decimals === 0) return group(String(Math.round(value / 100)), sep.thousands);
    var whole = group(String(Math.floor(value / 100)), sep.thousands);
    var fraction = value % 100;
    return fraction === 0 ? whole : whole + sep.decimal + String(fraction).padStart(2, '0');
  }

  function format(cents, options) {
    var opts = options || {};
    var value = Math.round(Number(cents) || 0);
    var sign = value < 0 ? '-' : '';
    value = Math.abs(value);

    var fmt = moneyFormat();
    var match = fmt ? fmt.match(PLACEHOLDER) : null;
    var sep = (match && SEPARATORS[match[1]]) || SEPARATORS.amount;
    var digits = number(value, sep);

    if (opts.withCode === false || !fmt) return sign + digits;
    return sign + decodeText(fmt.replace(PLACEHOLDER, digits));
  }

  root.twrdFormatMoney = format;
  if (typeof module !== 'undefined' && module.exports) module.exports = format;
})(typeof window !== 'undefined' ? window : globalThis);
